<template>
  <div class="clinic-list__before">
    <div class="clinic-list__count">
      <span v-if="clinicCount" v-text="clinicCount"></span>
    </div>
    <div v-if="showMapToggle" class="clinic-list__view">
      <FormToggleSwitch
          v-model="internalViewType"
          :options="{list: 'Списком', map:'На карте'}"
      >
        <template #list="{ label }">
          <SvgoClinicViewList class="toggle-switch_item-icon" aria-hidden="true"/>
          {{ label }}
        </template>

        <template #map="{ label }">
          <SvgoClinicViewMap class="toggle-switch_item-icon" filled aria-hidden="true"/>
          {{ label }}
        </template>
      </FormToggleSwitch>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  clinicCount: {
    type: [String, Number],
    default: ''
  },
  viewType: {
    type: String,
    required: true
  },
  showMapToggle: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['update:viewType']);

const internalViewType = computed({
  get: () => props.viewType,
  set: (value) => emit('update:viewType', value)
});
</script>

<style lang="scss">
.clinic-list {
  &__before {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    margin-bottom: 16px;

    & .toggle-switch_item {
      @include media(sm) {
        font-size: 0;
        gap: 0;
      }
    }
  }

  &__count {
    color: $color-gray;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;

    @include media(sm) {
      font-size: 16px;
    }
  }

  &__view {
    @include media(md, min-width) {
      display: none;
    }
  }
}
</style>